module.exports = __webpack_public_path__ + "static/img/89021B_2_3_R_20190129_LC.7973d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89021B_2_3_R_20190129_LC.png
// module id = 2jOA
// module chunks = 0